import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function EmptyPage({ target = "/" }) {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(target);
  });
  return <></>;
}

export default EmptyPage;
